import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Wordmark } from "@/components/Brand";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { api, formatApiError } from "@/lib/api";

export default function ForgotPassword() {
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await api.post("/auth/forgot-password", { email });
      setSent(true);
      toast.success(data.message || "Check your email for a reset link.");
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail) || "Please try again");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="bp-noise flex min-h-screen items-center justify-center px-4 py-10">
      <div className="w-full max-w-md">
        <button onClick={() => nav("/")} className="mb-8 flex justify-center" data-testid="forgot-logo">
          <Wordmark />
        </button>
        <div className="rounded-3xl border border-[#E8E4DF] bg-white p-7 bp-card-shadow bp-fade-up">
          <h1 className="font-display text-2xl font-semibold tracking-tight text-[#0F3D66]">
            Forgot your password?
          </h1>
          <p className="mt-1 text-sm text-[#6B6763]">
            Enter your email and we'll send you a link to reset it.
          </p>

          {sent ? (
            <div className="mt-6 space-y-4" data-testid="forgot-sent">
              <p className="rounded-xl bg-[#F6F3EF] p-4 text-sm text-[#44413E]">
                If an account exists for <strong>{email}</strong>, a reset link is on its way.
                The link is valid for 1 hour.
              </p>
              <Button onClick={() => nav("/auth")} data-testid="forgot-back-signin"
                className="h-11 w-full rounded-full bg-[#F36353] text-white hover:bg-[#D94A3D]">
                Back to sign in
              </Button>
            </div>
          ) : (
            <form onSubmit={submit} className="mt-6 space-y-4">
              <div>
                <Label htmlFor="email" className="text-[#0F3D66]">Email</Label>
                <Input id="email" type="email" required data-testid="forgot-email-input" value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  className="mt-1 rounded-xl border-[#E8E4DF] focus:border-[#F36353] focus-visible:ring-[#F36353]/20"
                  placeholder="you@email.com" />
              </div>
              <Button type="submit" disabled={loading} data-testid="forgot-submit-btn"
                className="h-11 w-full rounded-full bg-[#F36353] text-white hover:bg-[#D94A3D]">
                {loading ? "Please wait…" : "Send reset link"}
              </Button>
            </form>
          )}

          <p className="mt-5 text-center text-sm text-[#6B6763]">
            <button data-testid="forgot-to-signin" onClick={() => nav("/auth")}
              className="font-semibold text-[#F36353] hover:underline">
              Back to sign in
            </button>
          </p>
        </div>
      </div>
    </div>
  );
}
